import React, { useState, useEffect } from 'react';
import search_icon from '../../assets/images/search_icon.png';
import brownfilter_icon from '../../assets/images/brownfilter_icon.png';
import qrCode from '../../assets/svg/qrcode.svg';
import { GetAllAgentCommissions, MarkPaid } from '../../Services/AgentService';

export default function AgentCommission() {
  const [agentCommissions, setAgentCommissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedType, setSelectedType] = useState("");

  useEffect(() => {
    fetchAgentCommissions();
  }, []);

  const fetchAgentCommissions = async (searchTerm = "") => {
    setLoading(true);
    try {
      const params = {};
      if (searchTerm) params.filter = searchTerm;
      if (selectedType) params.includePaid = selectedType;
      const vendorId = localStorage.getItem("userId");
      if (vendorId) {
        params.vendorId = vendorId;
      }
      const response = await GetAllAgentCommissions(params);
      if (response.status) {
        setAgentCommissions(response.data);
      } else {
        setError(response.message);
      }
    } catch (err) {
      setError('Failed to fetch agent commissions');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      fetchAgentCommissions(searchTerm);
    }, [searchTerm,selectedType]);

  const handleMarkPaid = async (commissionId) => {
    try {
      const response = await MarkPaid(commissionId);
      if (response.status) {
        fetchAgentCommissions(); // Refresh the list
      } else {
        alert(response.message);
      }
    } catch (err) {
      alert('Failed to mark commission as paid');
    }
  };

  const renderTableBody = () => {
    if (!agentCommissions.length) {
      return (
        <tr>
          <td colSpan={7} className="text-center">No agent commissions available.</td>
        </tr>
      );
    }

    return agentCommissions.map((commission) => (
      <tr key={commission.id}>
        <td>{commission.agentName}</td>
        <td>{commission.kg?.toFixed(2)}</td>
        <td>{commission.commissionAmount?.toFixed(2)}</td>
        <td>{new Date(commission.createdOnUtc).toLocaleDateString()}</td>
        <td>{commission.isPaid ? 'Yes' : 'No'}</td>
        <td>{commission.paidDateUtc ? new Date(commission.paidDateUtc).toLocaleDateString() : '-'}</td>        
        <td className='d-flex justify-content-start align-items-center'>
          {!commission.isPaid && (
            <button
              className="add-product-btn"
              onClick={() => handleMarkPaid(commission.agentId)}
            >
              Mark Paid
            </button>
          )}
        </td>
      </tr>
    ));
  };

  return (
    <div className="dashboard mt-5">
<div className='order-list mt-5'>
      {/* Header */}
      <div className="d-flex align-items-center mt-4 mb-5">
        <div>
          <h2>Agent Commissions</h2>
        </div>
      </div>

      {/* Search bar */}
      <div className="order-header" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginBottom: '20px' }}>
        <div className="search-tools">
          <div className="search-wrapper">
            <input
              type="search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search Commission"
            />
            <div className="icons">
              <img src={search_icon} alt="Search" className="search-icon" />
              <img src={brownfilter_icon} alt="Filter" className="filter-icon" />
            </div>
          </div>
        </div>
        <div className="form-group" style={{marginBottom: "0"}}>
                <select style={{ minHeight: "70px",minWidth: "275px",cursor: "pointer" }}
                  value={selectedType}
                  onChange={(e) => {
                    setSelectedType(e.target.value);
                  }}
                >
                  <option value="">All</option>
                  <option value="true">Paid</option>
                  <option value="false">Un Paid</option>
                </select>
              </div>
      </div>

      {/* Agent Commissions Table */}
      <div className="order-table-wrapper">
        <table>
          <thead>
            <tr>
              <th style={{ fontSize: '19px', fontWeight: 400, paddingBottom: '17px' }}>Agent Name</th>
              <th style={{ fontSize: '19px', fontWeight: 400, paddingBottom: '17px' }}>Kg</th>
              <th style={{ fontSize: '19px', fontWeight: 400, paddingBottom: '17px' }}>Commission Amount</th>
              <th style={{ fontSize: '19px', fontWeight: 400, paddingBottom: '17px' }}>Created On</th>
              <th style={{ fontSize: '19px', fontWeight: 400, paddingBottom: '17px' }}>Is Paid</th>
              <th style={{ fontSize: '19px', fontWeight: 400, paddingBottom: '17px' }}>Paid Date</th>
              <th style={{ fontSize: '19px', fontWeight: 400, paddingBottom: '17px' }}>Action</th>
            </tr>
          </thead>
          <tbody>{renderTableBody()}</tbody>
        </table>
      </div>
    </div>
    </div>
  );
}